
(function () {
  if (customElements.get('lazy-video')) return;

  const ROOT_MARGIN = '200px';

  class LazyVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      // No IntersectionObserver support → just load it.
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }

      // Observe the <video>, not the host: the host is display:contents (no box),
      // so an observer on `this` would never report an intersection.
      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.load();
              break;
            }
          }
        },
        { rootMargin: ROOT_MARGIN },
      );
      this.observer.observe(this.video);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }

    load() {
      // Done observing — release it immediately.
      this.observer?.disconnect();
      this.observer = null;

      const video = this.video;
      if (!video || video.src) return;

      const src = video.dataset.src;
      if (!src) return;

      video.src = src;
      const played = video.play();
      if (played && typeof played.catch === 'function') played.catch(() => {});
    }
  }

  customElements.define('lazy-video', LazyVideo);
})();
